import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../api/../mutation-types";

const actions = {
  getSmInvoices({ commit }, payload) {
    return api.fetchFull(endpoints.SM_INVOICE_MANAGEMENT, payload, commit, (response) => {
      return response;
    });
  },

  getSmInvoiceByUuid({ commit }, payload) {
    return api.fetchFull(endpoints.SM_INVOICE_MANAGEMENT + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  createSmInvoice({ commit }, payload) {
    return api.post(endpoints.SM_INVOICE_MANAGEMENT, payload, commit, (response) => {
      return response;
    });
  },

  updateSmInvoice({ commit }, payload) {
    return api.put(endpoints.SM_INVOICE_MANAGEMENT + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  deleteSmInvoice({ commit }, payload) {
    return api.remove(endpoints.SM_INVOICE_MANAGEMENT + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

};

export default actions;
